import { React, useEffect, useState, useContext } from 'react'
import { MyContextProvider } from "../../../../App";
import axios from "axios";
import { API_URL, getAuthHeaders, getUserClaimsForUi } from '../../../../Constant';
import { GlobalLoading, showLoading } from 'react-global-loading';
import { shortMonthToFull, handleUserLevelAccessPermissions, getAllYears, validateRoles, validateMonthYears } from '../../../../Custom/Custom'
import { ToastContainer, toast } from 'react-toastify';
import { useNavigate } from "react-router-dom";
import titlesData from '../../../../titles.json';
import SixtySevenNecessaryItemsData from '../../../../Components/SixtySevenNecessaryItemsData';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import priceTitle from '../../../../price.json';
import othersTitle from '../../../../others.json';
import titlesHindi from '../../../../titles.json';


const SixtySevenNecessaryItems = () => {
  const [resetChild, setResetChild] = useState(false);
  const [loading, setLoading] = useState(false);
  const [districtList, setDistrictList] = useState([]);
  const [years, setYears] = useState([]);
  const [months, setMonth] = useState([]);
  const [districtCode, setDistrictCode] = useState('');
  const [yearName, setYearName] = useState('');
  const [monthName, setMonthName] = useState('');
  // const [startDate, setStartDate] = useState('');
  const [dateName, setDateName] = useState('');

  const [startDate, setStartDate] = useState();
  const [SixtySevenNecessaryItems, setSixtySevenNecessaryItems] = useState([]);
  const [payload, setPayload] = useState([]);
  const [isDivision, setIsDivision] = useState(false);
  const [isDistrict, setIsDistrict] = useState(false);
  const [buttonAccess, setButtonAccess] = useState({ userLevel: '', roles: '', isVisible: false });
  const token = useContext(MyContextProvider).token;
  const decode_token = getUserClaimsForUi();
  const navigate = useNavigate();
  const config = getAuthHeaders();


  useEffect(() => {

    const currentYear = new Date().getFullYear();

    // Set the current year as the default value for yearName
    setYearName(currentYear);

    const level = handleUserLevelAccessPermissions(decode_token);
    setButtonAccess(level)

    // get District By Division ID
    const getDistrictListByDivision = async () => {
      try {
        const response = await axios.post(
          `${API_URL}api/geDistrictListByDivisionId`,
          { division_Id: decode_token.id.USER_LEVEL_LOCATION }, config);
        const allDistrict = response.data;

        if (allDistrict.status) {
          setDistrictList(allDistrict.data);
          showLoading(false);
        }
      } catch (error) {
        console.error(error);
        showLoading(false);
      }
    }



    // All district list
    const getDistrictList = async () => {

      try {
        const response = await axios.get(`${API_URL}api/getallDistrictList`, config);
        const allDistrict = response.data;

        if (allDistrict.status) {
          setDistrictList(allDistrict.data);
          showLoading(false);
        }
      } catch (error) {
        console.error(error);
        showLoading(false);
      }
    };

    // Set district for district level
    const setDistrictForDistrictLevel = () => {
      const userDistrictCode = decode_token.id.USER_LEVEL_LOCATION;
      const userDistrictName = decode_token.id.LOCATION_NAME;

      const singleDistrict = [{
        DISTRICT_CODE: userDistrictCode,
        DISTRICT_NAME: userDistrictName
      }];

      setDistrictList(singleDistrict);
      setDistrictCode(userDistrictCode);
      setIsDistrict(true);
      showLoading(false);
    }

    //Get all Months data    
    const getMonthsList = (e) => {
      showLoading(true)
      axios
        .get(`${API_URL}api/graph/getMonths/2019`, config)
        .then((res) => {
          let monthDataResponse = res.data;
          if (monthDataResponse.status) {
            setMonth(monthDataResponse.data);
            showLoading(false)
          }
        })
        .catch((err) => {
          console.error(err);
          showLoading(false);
        });
    }


    const getYearList = () => {
      const startYear = 2014; // Starting year
      const endYear = new Date().getFullYear(); // Ending year

      const yearsArray = [];
      for (let year = startYear; year <= endYear; year++) {
        yearsArray.push(year);
      }

      setYears(yearsArray);
    };

    const pageLoadSixtySevenNecessaryItems = () => {
      showLoading(true);
      axios
        .get(`${API_URL}api/otherPrices/SixtySevenNecessaryItemsForm`, config)
        .then((res) => {

          const { data, success } = res.data;
          if (success) {
            setSixtySevenNecessaryItems(data);
            setTimeout(() => (showLoading(false)), 3000)
          }
        }).catch((err) => {
          console.log(err)
          showLoading(false);
        });
    }

    const userRole = async () => {
      showLoading(true)
      try {
        const role = await validateRoles(decode_token)
        if (role) {

          pageLoadSixtySevenNecessaryItems();
          // SixtySevenNecessaryItemsInputFormDataUnitList();
          getYearList();
          getMonthsList();

          if (level.userLevel === 'DIVISION LEVEL' && level.roles.includes('DIVADM')) {
            getDistrictListByDivision()
            setIsDivision(true)
          } else if(level.userLevel === 'DISTRICT LEVEL'){
            setDistrictForDistrictLevel()
          } else {
            getDistrictList()
          }

        } else {

          alert("You are not an authorized user to capture the data for Pricing");
          navigate("/dashboard");
        }
      } catch (error) {
        console.log(error);
        showLoading(false)
      }
    }


    userRole();


  }, []);


  const handleDropdownChange = async (e) => {
    switch (e.target.name) {
      case 'district_name':
        setDistrictCode(e.target.value);
        break;
      case 'month_name':
        setMonthName(e.target.value);
        setStartDate(null);
        break;
      case 'year_name':
        setYearName(e.target.value);
        break;
      default:
        console.log("switch case does not match");
        break;
    }



    const distCode = e.target.name === 'district_name' ? e.target.value : districtCode;

    if (e.target.name === 'startDate') {
      const selectedDate = new Date(e.target.value);
      const utcDate = new Date(selectedDate.getTime() - (selectedDate.getTimezoneOffset() * 60000));
      const formattedDate = utcDate.toISOString().split('T')[0]; // Format to YYYY-MM-DD

      setStartDate(utcDate);
      setDateName(formattedDate);
    }
    // Check if all necessary fields are selected
    if (distCode && monthName !== '' && yearName !== '') {
      let postData = {
        "district_code": distCode,
        "month_name": monthName >= 10 ? monthName.toString() : `0${monthName}`,
        "year_name": yearName,
        "date_name": startDate

      };


      showLoading(true);

      try {
        // Make API call to fetch data
        const response = await axios.post(`${API_URL}api/otherPrices/SixtySevenNecessaryItemsFormWithData`, postData, config);
        if (response.data.status) {
          setSixtySevenNecessaryItems(response.data.data[0].GroupCodes);
          setPayload(response.data.data[1].payload);
          showLoading(false);
        }
      } catch (error) {
        console.error('Error posting data:', error);
        showLoading(false);
      }
    }
    setResetChild(!resetChild);
  };
  const resetMonthAndYearField = () => {
    setMonthName('')
    setYearName('')
    if(!isDistrict){
      setDistrictCode('')
    }
    setStartDate(null); // Reset the date picker value to null
    setDateName('')

    setResetChild(!resetChild);

  }

  const filterFriday = (date) => {
    if (date.getDay() === 5) {
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      return date <= today;
    }
    return false;
  };

  const handleDateChange = async (date) => {
    if (date) {
      const utcDate = new Date(date.getTime() - (date.getTimezoneOffset() * 60000));
      const formattedDate = utcDate.toISOString().split('T')[0]; // Format to YYYY-MM-DD

      setStartDate(utcDate);
      setYearName(utcDate.getFullYear());
      setMonthName(utcDate.getMonth() + 1);
      setDateName(formattedDate); // Ensure formattedDate is used here

      let monthName = utcDate.getMonth() + 1;

      if (districtCode && monthName !== '' && yearName !== '') {
        let postData = {
          "district_code": districtCode,
          "month_name": monthName >= 10 ? monthName.toString() : `0${monthName}`,
          "year_name": yearName,
          "date_name": formattedDate
        };


        try {
          showLoading(true);
          const response = await axios.post(`${API_URL}api/otherPrices/SixtySevenNecessaryItemsFormWithData`, postData, config);
          if (response.data.status) {
            setSixtySevenNecessaryItems(response.data.data[0].GroupCodes);
            setPayload(response.data.data[1].payload);
          }
        } catch (error) {
          console.error('Error posting data:', error);
        } finally {
          showLoading(false);
        }
      }
    }
  };

  const storedLanguage = localStorage.getItem('language');

  // const getMonthName = (index) => {
  //   const monthNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
  //   return monthNames[index];
  // };

  const currentMonth = new Date().getMonth();
  const currentYear = new Date().getFullYear();
  return (
    <>
      <ToastContainer />
      <GlobalLoading />
      <div className="container-fluid py-3">
        {loading && <div>Loading...</div>}
        <div className='card_white mx-3 mb-3'>
          <div className="row align-items-center">
            <div className="col-12 mb-3">
              <h4 className="page_heading">
                <div dangerouslySetInnerHTML={{ __html: storedLanguage === 'hi' ? priceTitle.hi.SIXTY_SEVEN_NECESSARY_ITEMS : priceTitle.en.SIXTY_SEVEN_NECESSARY_ITEMS }} />
              </h4>
            </div>
          </div>
          <div className="row align-items-center">
            {isDivision &&
              <div className="col-xl-2 col-lg-3 col-md-4 col-sm-6 col-6 mb-3">
                <label>{storedLanguage === 'hi' ? titlesData.hi.DIVISION : titlesData.en.DIVISION}</label>
                <input type="text" className="form-control" disabled value={decode_token.id.LOCATION_NAME} />
              </div>
            }

            <div className="col-xl-2 col-lg-3 col-md-3 col-sm-4 col-6 mb-3">
              <label className="w-100">{storedLanguage === 'hi' ? othersTitle.hi.SELECT_DATE : othersTitle.en.SELECT_DATE}</label>
              <DatePicker
                className="form-control calendar_icon"
                dateFormat="yyyy-MM-dd"
                placeholderText="YY-MM-DD"
                selected={startDate}
                onChange={handleDateChange}
                filterDate={filterFriday}
                maxDate={new Date()}
                renderCustomHeader={({
                  date,
                  changeYear,
                  changeMonth,
                  decreaseMonth,
                  increaseMonth,
                  prevMonthButtonDisabled,
                  nextMonthButtonDisabled,
                }) => (
                  <div
                    style={{
                      margin: 10,
                      display: "flex",
                      justifyContent: "center",
                    }}
                  >
                    <button onClick={decreaseMonth} disabled={prevMonthButtonDisabled}>
                      {"<"}
                    </button>
                    <select
                      onChange={(e) => {
                        setYearName(parseInt(e.target.value));
                        changeYear(parseInt(e.target.value));
                      }}
                      value={yearName}
                    >
                      <option value="" disabled>Select Year</option>
                      {years &&
                        years.map((ele, index) => (
                          <option key={index} value={ele}>
                            {ele}
                          </option>
                        ))}
                    </select>
                    <select
                      value={date.getMonth()}
                      onChange={(e) => {
                        setMonthName(e.target.value);
                        changeMonth(e.target.value);
                      }}
                    >
                      <option value="" disabled>Select Month</option>
                      {months &&
                        months
                          .filter((_, i) => !(new Date().getFullYear() === yearName && i > currentMonth))
                          .map((ele, i) => (
                            <option key={i} value={i}>
                              {shortMonthToFull(ele.MONTH)}
                            </option>
                          ))}
                    </select>
                    <button onClick={increaseMonth} disabled={nextMonthButtonDisabled}>
                      {">"}
                    </button>
                  </div>
                )}
              />
            </div>
            {isDistrict && (
              <div className="col-xl-2 col-lg-3 col-md-3 col-sm-4 col-6 mb-3">
                <label>{storedLanguage === 'hi' ? titlesData.hi.DISTRICT : titlesData.en.DISTRICT}</label>
                <input type="text" className="form-control" disabled value={decode_token.id.LOCATION_NAME} />
              </div>
            )}
            {!isDistrict && (
              <div className="col-xl-2 col-lg-3 col-md-3 col-sm-4 col-6 mb-3">
                <label>{storedLanguage === 'hi' ? titlesData.hi.DISTRICT : titlesData.en.DISTRICT}</label>
                <select
                  name="district_name"
                  id="district_name"
                  className="form-select"
                  onChange={handleDropdownChange}
                  value={districtCode}
                >
                  <option value="" disabled>Select District</option>
                  {districtList &&
                    districtList
                      .slice()
                      .sort((a, b) => a.DISTRICT_NAME.localeCompare(b.DISTRICT_NAME))
                      .map((ele, index) => (
                        <option key={index} value={ele.DISTRICT_CODE}>
                          {ele.DISTRICT_NAME}
                        </option>
                      ))}
                </select>
              </div>
            )}
            <div className="col-xl-2 col-lg-3 col-md-3 col-sm-4 col-6 mb-3">
              <label>{storedLanguage === 'hi' ? titlesData.hi.MONTH : titlesData.en.MONTH}</label>
              <div className="d-flex align-items-center">
                <select
                  name="month_name"
                  id="month_name"
                  className="form-select"
                   onChange={handleDropdownChange}
                    value={monthName}
                >
                  <option value="" disabled>Select Month</option>
                  {months &&
                    months
                      .filter((_, i) => !(currentYear === yearName && i > currentMonth))
                      .map((ele, i) => (
                        <option key={i + 1} value={i + 1}>
                          {shortMonthToFull(ele.MONTH)}
                        </option>
                      ))}
                </select>
              </div>
            </div>
            <div className="col-xl-2 col-lg-3 col-md-3 col-sm-4 col-6 mb-3">
              <label>{storedLanguage === 'hi' ? titlesData.hi.CURRENT_YEAR : titlesData.en.CURRENT_YEAR}</label>
              <input
                type="text"
                className="form-control"
                disabled
                value={yearName}
                readOnly
              />
            </div>
          </div>
        </div>
        <div className="card mx-3 mb-3 date_picket_z_index">
          {SixtySevenNecessaryItems.length > 0 &&
            <SixtySevenNecessaryItemsData
              type="urban"
              payload={payload}
              districtCode={districtCode}
              config={config}
              resetMonthAndYearField={resetMonthAndYearField}
              userInfoObject={buttonAccess}
              yearName={yearName}
              monthName={monthName}
              dateName={dateName}
              blockCode=''
              SixtySevenNecessaryItemsPrice={SixtySevenNecessaryItems}
              titlesData={titlesData}
              storedLanguage={storedLanguage}
              priceTitle={priceTitle}
              othersTitle={othersTitle}
              titlesHindi={titlesHindi}
            />
          }
        </div>
      </div>
    </>
  )
}

export default SixtySevenNecessaryItems